export var MuiTooltip = {
  styleOverrides: {
    tooltipPlacementRight: function tooltipPlacementRight(_ref) {
      var theme = _ref.theme;
      return {
        marginLeft: "".concat(theme.spacing(1), " !important")
      };
    }
  }
};
//# sourceMappingURL=MuiTooltip.js.map